import { useEffect } from "react";
import { LuLoaderCircle } from "react-icons/lu";
import QuoteFormWrapper from "./quoteFormWrapper";
import QuoteStepHeading from "./QuoteStepHeading";
import PageContentStack from "./PageContentStack";
import { scrollToTop } from "../utils/scrollUtils";

const QuoteStepLoader = ({ title, description, message }) => {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <PageContentStack>
      <QuoteFormWrapper>
        <QuoteStepHeading title={title} description={description} />
        <div
          className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-3 tw-rounded-dis-card tw-bg-dis-info-panel tw-px-5 tw-py-8 tw-text-center"
          role="status"
          aria-live="polite"
        >
          <LuLoaderCircle
            className="tw-h-8 tw-w-8 tw-animate-spin tw-text-dis-deep-blue"
            aria-hidden="true"
          />
          <p className="tw-m-0 tw-text-base tw-text-dis-text-muted">{message}</p>
        </div>
      </QuoteFormWrapper>
    </PageContentStack>
  );
};

export default QuoteStepLoader;
